import { Component, h } from 'preact';
import { BookingState, connectStore } from '../../store';
import { AmDurationItem, AmDurationType, AmHolidayType, getKey, Key, Properties } from '../../common';
import { WithStyles } from '../../style';
import Selector from '../../common/Selector/Selector';
import { stopPropagation } from '../../utils';
import DurationModal from './DurationModal/DurationModal';
import { FinText } from '../../i18n';

export interface DurationSelectorProps extends Properties {}

interface StoreProps {
  durationItem: AmDurationItem | undefined;
}

type EffectiveProps = DurationSelectorProps & StoreProps & WithStyles;

const mapStateToProps = ({ amState: { amSelection } }: BookingState): StoreProps => {
  const duration: string = amSelection.duration;
  const holidayType: AmHolidayType = amSelection.locations.holidayType;
  const durationItem: AmDurationItem =
    holidayType && holidayType.type === AmDurationType.LIST
      ? holidayType.items.find((value) => value.code === duration)
      : undefined;
  return { durationItem };
};

@connectStore({ mapStateToProps })
export default class DurationSelector extends Component<DurationSelectorProps> {
  openModal = (e: Event): void => {
    stopPropagation(e);
    this.context.modal.showModal(<DurationModal />);
  };

  handleKeyUp = (e: KeyboardEvent): void => {
    const key: Key = getKey(e);
    if (key === Key.ENTER || key === Key.SPACE) {
      this.openModal(e);
    }
  };

  render({ durationItem }: EffectiveProps): h.JSX.Element {
    return (
      <Selector class={this.props.class} onClick={this.openModal} onKeyUp={this.handleKeyUp}>
        <div class="nordic-blue-900-text font-body-1 regular-type">
          <FinText id="aurinkomatkat.duration" />
        </div>
        <div class="nordic-blue-900-text medium-type font-heading-5">
          {durationItem?.label}
          {!durationItem && <FinText id="aurinkomatkat.selectDuration" />}
        </div>
      </Selector>
    );
  }
}
